import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import {
  Add,
  CenterFocusStrong,
  Code,
  Delete,
  Edit,
  MoreHoriz,
  PhoneAndroid,
  TrendingFlat,
  ViewCarousel,
} from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";

//Modals
import DownloadQRCodes from "./Modals/DownloadQRCodes";
import Move from "./Modals/Move";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";
import MassEdit from "../Tafels/Modals/MassEdit";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import { toast } from "react-toastify";
import AreYouSureDialog from "../../components/Dialogs/AreYouSureDialog";
import { Dialog } from "@mui/material";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      simulatorModal: false,
      DownloadQRCodeModal: false,
      moveModal: false,
      selectedIds: [],

      massEditModal: false,
      showDeleteAlert: false,
    };
  }

  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current.refreshData();
  };

  canCreateNieuwItem = () => {
    return this.props.vestiging_id && Number.isFinite(Number(this.props.vestiging_id));
  };

  genWebcode = () => {
    let vestiging_id = this.props.vestiging_id;

    axios.post("core/tafels/genwebcode", { salesarea_ids: vestiging_id }).then((response) => {
      toast.success(<TranslationWrapper tDefault={"Webcodes gegenereerd"} tKey={"tafels.message.genwebcode"} />);
      this.refreshJamezzTable();
    });
  };

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleSimulatorAction = (row) => {
    if (import.meta.env.MODE === "production") {
      // Production
      let qrCode = row[1].replace(/([\ ]+).*/g, "$1").trim();
      let url =
        "https://jamezz.app/qr/" +
        qrCode +
        "?token=wekrjgnaiku3wjrngahijk3rwnbgi2hwqoir3uqewoiasl&v=99&deviceid=jamezzTest&platform=android";
      window.open(url, "Jamezz Simulator", "menubar=0,scrollbars=0,status=0,width=1024,height=768");
    } else {
      // Local
      let webCode = row[1].replace(/.*<b>([^<]+)<\/b>.*/g, "$1");
      let url = location.origin + "/dl/" + webCode + "?ignoreTargetPlatform";
      window.open(url, "Jamezz Simulator", "menubar=0,scrollbars=0,status=0,width=1024,height=768");
    }
  };

  handleMoveAction = (row) => {
    this.setState({
      moveModal: true,
      selectedIds: [row[0]],
    });
  };

  handleMoveSuccess = () => {
    this.setState({
      moveModal: false,
      selectedIds: [],
    });

    this.refreshJamezzTable();
  };

  handleMultieSelect = (ids) => {
    this.setState({ selectedIds: ids });
  };

  handleMultiDelete = () => {
    const data = {
      ids: this.state.selectedIds,
    };

    axios.post("core/tafels/multipledelete", data).then((response) => {
      const aantal = response.data.data.deleted;
      this.toggleModal("showDeleteAlert");
      toast.warn(aantal + " items verwijderd");
      this.refreshJamezzTable();
    });
  };

  hideDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  customData_masterCode = (item) => {
    return item.qr_code?.masterCode
      ? "<small><center>" +
          getTranslation("tafels.jamezztable.customdata.mastercode", "mastercode") +
          "<br>" +
          item.qr_code.masterCodeType +
          "</center><small>"
      : "";
  };

  customData_qr_wb_api = (item) => {
    return (
      (item?.qr_code?.code ?? "") +
      " / <b>" +
      (item?.qr_code?.mid ?? "") +
      "</b><br /><i>" +
      (item.apiId1 ? item.apiId1 : getTranslation("tafels.noapi", "n/a")) +
      "</i>"
    );
  };

  render() {
    const { classes } = this.props;

    let actions = [
      {
        icon: CenterFocusStrong,
        tooltip: <TranslationWrapper tDefault={"Download QR"} tKey={"tafels.table.tooltip.downloadQr"} />,
        actionType: "download",
        action: "/qrs/code/gentafel/:id?download=true",
      },
      {
        icon: PhoneAndroid,
        tooltip: <TranslationWrapper tDefault={"Simulator"} tKey={"tafels.table.tooltip.simulator"} />,
        actionType: "action",
        action: this.handleSimulatorAction,
      },
    ];

    actions.push({
      permissionKey: "tafels.move",
      icon: TrendingFlat,
      tooltip: <TranslationWrapper tDefault={"verplaatsen"} tKey={"tafels.table.tooltip.move"} />,
      actionType: "action",
      action: this.handleMoveAction,
    });

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Tafels overzicht"} tKey={"tafels.pagetitle"} />} />
        <GridContainer>
          {this.canCreateNieuwItem() ? (
            <GridItem xs={12}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Nieuwe tafel"} tKey={"tafels.nieuw.item"} />
                </Button>
              </Link>
              <Link to={"./bulk"}>
                <Button className={classes.marginRight} color={"success"}>
                  <MoreHoriz className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Bulk aanmaken"} tKey={"tafels.bulkAanmaken"} />
                </Button>
              </Link>
              <Button className={classes.marginRight} color={"success"} onClick={this.genWebcode}>
                <Code className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"generate webcode"} tKey={"tafels.genWebcode"} />
              </Button>
            </GridItem>
          ) : null}

          {this.state.selectedIds.length > 0 ? (
            <GridItem>
              <Button
                className={classes.marginRight}
                color={"success"}
                onClick={() => this.toggleModal("DownloadQRCodeModal")}
              >
                <CenterFocusStrong className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"QRcodes"} tKey={"tafels.downloadQrCode"} />
              </Button>
            </GridItem>
          ) : null}

          {this.state.selectedIds.length > 0 ? (
            <AuthenticationWrapper permissionKey={"tafels.move"}>
              <GridItem>
                <Button className={classes.marginRight} color={"success"} onClick={() => this.toggleModal("moveModal")}>
                  <TrendingFlat className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Verplaatsen"} tKey={"tafels.move"} />
                </Button>
              </GridItem>
            </AuthenticationWrapper>
          ) : null}

          {this.state.selectedIds.length > 0 ? (
            <Button className={classes.marginRight} color={"success"} onClick={() => this.toggleModal("massEditModal")}>
              <Edit className={classes.icons} />
              <TranslationWrapper tDefault={"aanpassen"} tKey={"producten.massEdit"} />
            </Button>
          ) : null}

          {this.state.selectedIds.length > 0 ? (
            <AuthenticationWrapper permissionKey={"tafels.delete"}>
              <GridItem>
                <Button
                  className={classes.marginRight}
                  color={"danger"}
                  onClick={() => this.toggleModal("showDeleteAlert")}
                >
                  <Delete className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />
                </Button>
              </GridItem>
            </AuthenticationWrapper>
          ) : null}
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"naam"}
              fieldKey={"tafels:naam"}
              operator={"like"}
              placeholder={getTranslation("tafels.filter.tafel", "Filter op tafel")}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                { dbfield: "id", editable: false },
                { customData: this.customData_qr_wb_api },
                { dbfield: "naam", editable: true, inputtype: "Input" },
                { dbfield: "sector", editable: true, inputtype: "Input" },
                { dbfield: "zone.zoneName", editable: false },
                { customData: this.customData_masterCode },
              ]}
              dbfields={
                "id,qrCode.code,apiId1,qrCode.mid,naam,sector,qrCode.tafel_id,qrCode.masterCode,qrCode.masterCodeType,zone_id,zone.id,zone.zoneName"
              }
              delete={"tafels.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"tafels/:id/edit"}
              fetchUrl={"core/tafels"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                {
                  label: getTranslation("tafels.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                { label: getTranslation("tafels.table.qr", "Qr / WC<br />ApiID"), sortable: false },
                /*{ label: getTranslation("tafels.table.wc", "WC"), sortable: false },
                { label: getTranslation("tafels.table.apiId1", "Api ID"), sortable: false },*/
                {
                  label: getTranslation("tafels.table.naam", "Naam"),
                  width: "30%",
                  sortable: true,
                  sortKey: "naam",
                  sortType: "natural",
                },
                {
                  label: getTranslation("tafels.table.sector", "Sector"),
                  width: "25%",
                  sortable: false,
                },
                {
                  label: getTranslation("tafels.table.zones", "Zone"),
                  width: "7%",
                  sortable: false,
                },
                {
                  label: "", // Column for mastercode: using an empty header
                  width: "3%",
                  sortable: false,
                },
              ]}
              multieSelect
              multieSelectHandler={this.handleMultieSelect}
              reduxKey={"tafels"}
              ref={this.jamezzTable}
              tableTitle={<TranslationWrapper tDefault={"Tafels"} tKey={"tafels.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        {/*POPUPS*/}
        {/* <Simulator
                    open={this.state.simulatorModal}
                    toggle={() => this.toggleModal('simulatorModal')}
                    qrCode={this.state.simulatorQr}
                    {...this.props}
                /> */}

        <DownloadQRCodes
          open={this.state.DownloadQRCodeModal}
          selectedTafelIds={this.state.selectedIds}
          toggle={() => this.toggleModal("DownloadQRCodeModal")}
          {...this.props}
        />

        {this.state.massEditModal ? (
          <MassEdit
            open={this.state.massEditModal}
            refreshTable={() => this.refreshJamezzTable()}
            tafelIds={this.state.selectedIds}
            toggle={() => this.toggleModal("massEditModal")}
          />
        ) : null}

        <Move
          handleSuccess={this.handleMoveSuccess}
          open={this.state.moveModal}
          selectedTafelIds={this.state.selectedIds}
          toggle={() => this.toggleModal("moveModal")}
          {...this.props}
        />
        <Dialog open={this.state.showDeleteAlert}>
          <AreYouSureDialog
            content={this.state.selectedIds.length + " item(s)"}
            onCancel={this.hideDeleteAlert}
            onOk={this.handleMultiDelete}
            title={<TranslationWrapper tDefault={"Weet je het zeker?"} tKey={"global.jamezztable.confirm"} />}
          />
        </Dialog>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["tafels:naam"]) {
    filters["tafels:naam"] = state.filtersV2["tafels:naam"];
  }
  return {
    user_id: state.user.id,
    filters: filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tafelStyle));
